const _excluded = ["fieldName", "value", "onChange", "dataTestId", "id", "thousandSeparator", "decimalSeparator", "size", "style", "formGroupClasses", "onlyPositiveNumbers", "showOverlay"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChangeHighlighter, FormattedNumberInput } from '..';
const DEFAULT_ID_PREFIX = 'integer_form_field';
const hasNonZeroDecimalPart = value => {
  if (value === null || value === undefined || value === '') {
    return false;
  }
  const decimalPart = String(value).split('.')[1];
  return decimalPart && /[1-9]/.test(decimalPart);
};
export function IntegerFormFieldRow(_ref) {
  let {
      fieldName,
      value,
      onChange = () => {},
      dataTestId,
      id: idProp,
      thousandSeparator = '.',
      decimalSeparator = ',',
      size = 'sm',
      style = {
        width: '100px'
      },
      formGroupClasses = '',
      onlyPositiveNumbers = true,
      showOverlay = true
    } = _ref,
    restProps = _objectWithoutProperties(_ref, _excluded);
  const {
    t
  } = useTranslation();
  const id = idProp !== null && idProp !== void 0 ? idProp : "".concat(DEFAULT_ID_PREFIX, "_").concat(fieldName).replace(/\./g, '_');
  const testId = dataTestId !== null && dataTestId !== void 0 ? dataTestId : id;
  const fieldObject = {
    [fieldName]: value
  };
  const showDecimalWarning = hasNonZeroDecimalPart(value);
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": testId,
    className: "IntegerFormFieldRow IntegerFormFieldRow-".concat(fieldName, " ").concat(formGroupClasses)
  }, /*#__PURE__*/React.createElement(ChangeHighlighter, _extends({
    as: FormattedNumberInput,
    thousandSeparator: thousandSeparator,
    decimalSeparator: decimalSeparator,
    decimalScale: 0,
    object: fieldObject,
    name: fieldName,
    type: "text",
    size: size,
    onlyPositiveNumbers: onlyPositiveNumbers,
    onChange: onChange,
    style: style,
    showOverlay: showOverlay,
    "data-testid": "".concat(testId, "-input")
  }, restProps)), showDecimalWarning && /*#__PURE__*/React.createElement("small", {
    className: "text-warning d-block mt-1",
    "data-testid": "".concat(testId, "-decimal-warning")
  }, t('integer_field_non_round_decimal_warning', {
    value: String(value),
    defaultValue: 'This field has received the decimal value {{value}}. The number received from the backend is not round. Contact admin.'
  })));
}